<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("Download") }}
      </p>
    </div>
    <div class="modal-card-body">
      <b-loading :active="isLoading" :is-full-page="false"></b-loading>
      <b-progress
        v-if="isLoading"
        show-value
        type="is-primary"
        :value="downloadedPages"
        format="percent"
        size="is-medium"
        :max="totalPages"
      ></b-progress>

      <b-field :label="$t('Image')">
        <div class="notification">
          <b-checkbox v-model="addImage">
            {{ $t("Add images") }}
          </b-checkbox>
        </div>
      </b-field>
      <b-field :label="$t('Text')">
        <div class="notification">
          <b-field :label="xml.label">
            <b-checkbox v-model="addXML">
              {{ $t("Add XML") }}
            </b-checkbox>
          </b-field>
          <b-field :label="txt.label">
            <b-checkbox v-model="addText">
              {{ $t("Add text") }}
            </b-checkbox>
          </b-field>
        </div>
      </b-field>
    </div>
    <div class="modal-card-foot">
      <div class="is-flex" style="width: 100%">
        <b-button
          tag="a"
          @click="confirm()"
          icon-left="download"
          style="min-width: 3rem"
          v-if="addXML || addImage || addText"
        >
          {{ $t("Download") }}
        </b-button>
        <b-button
          v-else
          tag="a"
          @click="confirm()"
          icon-left="download"
          style="min-width: 3rem"
          disabled
        >
          {{ $t("Download") }}
        </b-button>
        <b-button
          @click="$parent.close"
          type="is-primary"
          style="margin-left: auto"
        >
          {{ $t("Close") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Level from "@/components/Level.vue";
import imageMixin from "@/mixins/image.js";
import contentMixin from "@/mixins/content.js";

import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";

import api from "@/api";

export default {
  mixins: [imageMixin, contentMixin],
  components: {
    Level,
  },
  props: {
    docId: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      txt: {
        label: "TXT",
        data: null,
        filename: `${this.contentKey}.txt`,
      },
      offset: 0,
      downloadedPages: 0,
      totalPages: 0,
      addImage: false,
      addXML: false,
      addText: false,
      xmls: [],
      images: [],
      title: "Document",
      isLoading: false,
    };
  },
  computed: {
    xml() {
      return {
        label: "Prima Page Content XML",
        source: this.getContentXMLSource(this.contentKey),
      };
    },
  },
  async mounted() {
    var offset = 0;
    var limit = this.total;
    const data = await this.api.fetchDocumentPages(this.docId, {
      offset,
      limit,
    });
    this.xmls = data.items.map(function(item) {
      return item["xmlKey"];
    });
    this.images = data.items.map(function(item) {
      return item["imageURL"];
    });
    this.title = data.items[0].title;
  },
  methods: {
    async loadPageContentJson(key) {
      var data = await this.api.fetchContent(key);
      const txt = this.convertContentToText(data.PcGts.Page);
      return txt;
    },
    confirm() {
      this.$buefy.dialog.confirm({
        message: this.$t("Start download? Window can be closed and download will still continue."),
        onConfirm: () => this.zip(),
      });
    },
    convertContentToText(data) {
      return (data.elements || [])
        .map((content) => {
          return (content.elements || [])
            .map((item) => {
              return this.extractText(item);
            })
            .join("\r\n");
        })
        .join("\r\n\r\n");
    },
    extractText(item) {
      const clean = (s) =>
        typeof s !== "string" ? "" : s.trim().replace(/¬$/, "\u2010");
      return item.elements && item.elements[0]
        ? clean(item.elements[0].text)
        : "";
    },
    async zipText(zip, zipFilename) {
      var textNr = 0;
      for (var xml in this.xmls) {
        textNr++;
        var tempXml = this.xmls[xml].replace(
          "https://files.transkribus.eu/Get?id=",
          ""
        );
        var file = await this.loadPageContentJson(tempXml);
        var filename = this.title + "-" + textNr + ".txt";
        zip.file(filename, file, { binary: true });
        this.downloadedPages++;
      }
      this.saveZip(zip, zipFilename);
    },
    async saveZip(zip, zipFilename) {
      await zip.generateAsync({ type: "blob" }).then(function(content) {
        saveAs(content, zipFilename + ".zip");
      });
      this.downloadedPages = 0;
      this.isLoading = false;
    },
    async zip() {
      var urls = [];
      this.isLoading = true;
      const zip = new JSZip();
      let count = 0;
      let that = this;

      const zipFilename = this.title;
      if (this.addText) {
        this.totalPages += this.xmls.length;
      }
      if (this.addImage || this.addXML) {
        if (this.addImage) {
          urls = urls.concat(this.images);
          this.totalPages += this.xmls.length;
        }
        if (this.addXML) {
          urls = urls.concat(this.xmls);
          this.totalPages += this.xmls.length;
        }

        var wait = new Promise((resolve, reject) => {
          var imageNr = 0;
          var xmlNr = 0;
          urls.forEach(async function(url) {
            const urlArr = url.split("/");
            let filename = urlArr[urlArr.length - 1];
            if (filename.includes("view")) {
              imageNr++;
              filename = that.title + "-" + imageNr + ".jpg";
            } else {
              xmlNr++;
              filename = that.title + "-" + xmlNr + ".xml";
            }
            try {
              const file = await JSZipUtils.getBinaryContent(url);
              zip.file(filename, file, { binary: true });
              count++;
              that.downloadedPages++;
              if (count === urls.length) {
                resolve();
              }
            } catch (err) {
              that.$buefy.toast.open({
                duration: 5000,
                message: `Failed to download document`,
                position: "is-top",
                type: "is-danger",
              });
            }
          });
        });
        wait.then(() => {
          if (this.addText) {
            this.zipText(zip, zipFilename);
          } else {
            this.saveZip(zip, zipFilename);
          }
        });
      } else {
        this.zipText(zip, zipFilename);
      }
    },
  },
};
</script>
